<template>
  <header>
    <div id="logoCont">
      <BLogoHeader />
      <h1>
        <b>BERG</b> ENTERPRISES
      </h1>
    </div>
    <div id="linkCont">
      <div id="links">
        <HeaderLink v-for="link in navLinks"
          :key="link.title"
          :linkTitle="link.name"
          :linkDest="link.el"
        />
      </div>
      <div id="highlights">
        <NavHighlight v-for="link in navLinks"
          :key="link.title"
          :linkTitle="link.name"
        />
      </div>
    </div>
  </header>
</template>

<script>
import HeaderLink from '../nav/HeaderLink.vue'
import BLogoHeader from '../nav/BLogoHeader.vue'
import NavHighlight from '../nav/NavHighlight.vue'

export default {
  name: 'HeaderCompDesktop',
  components: {
    HeaderLink,
    BLogoHeader,
    NavHighlight
  },
  
  data() {
    return {
      
    }
  },
  
  computed: {
    navLinks() {
      return this.$store.state.nav.links;
    }
  }
}
</script>

<style scoped>
  header {
    border: solid green 0px;
    background-image: linear-gradient(180deg, rgba(250,250,250,1) 0%, rgba(250,250,250,1) 1%, rgba(250,250,250,0.92) 10%, rgba(11,7,22,1) 90%, rgba(11,7,22,1) 91%, rgba(11,7,22,0.92) 100%);
    background-size: 100% 1000%;
    background-position: var(--nav-grad-pos);
    box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.12);
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    height: 60px;
    width: 100%;
    position: fixed;
    transition: ease-in-out 400ms;
    overflow: hidden;
    z-index: 100;
  }
  
  h1 {
    font-family: Futura,Trebuchet MS,Arial,sans-serif;
    font-weight: normal;
    font-size: 22px;
    text-shadow: 0px 1px 3px rgba(0, 0, 0, .2);
    width: 218px;
    height: 30px;
    border: solid green 0px;
    text-align: center;
    margin: 0px 0px 0px 6px;
    color: var(--logo-text);
    transition-duration: 1000ms;
  }
  
  #logoCont {
    width: 258px;
    height: 33px;
    border: solid yellow 0px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin: 0px 0px 0px 22px;
  }
  
  #logoText {
    width: 207px;
    height: 27px;
    transform: translateY(1px);
  }
  
  #linkCont {
    border: solid blue 0px;
    display: flex;
    flex-direction: row;
    margin: 0px 20px 0px 0px;
    position: relative;
  }

  #links {
    position: relative;
    display: flex;
  }

  #highlights {
    position: absolute;
    width: 100%;
    bottom: -19px;
    border: solid red 0px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
</style>
